import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Injector, Input, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

import { ValidatorsServiceHelper } from '../../helper';

@Component({
  selector: 'app-error-validation-message',
  standalone: true,
  imports: [NgIf],
  templateUrl: './error-validation-message.component.html',
  styleUrls: ['./error-validation-message.component.scss'],
})
export class ErrorValidationMessageComponent implements OnInit {
  @Input() control!: AbstractControl;
  @Input() errors: ValidationErrors;
  message!: string;

  constructor(private validatorsServiceHelper: ValidatorsServiceHelper, private injector: Injector) {}

  ngOnInit() {
    this.listenToControlChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['errors'] && changes['errors'].currentValue) {
      this.errors = changes['errors'].currentValue;
      this.listenToControlChanges();
    }
  }
  // privates
  private async errorMessage(): Promise<string> | null {
    for (const validatorName in this.errors) {
      return await this.validatorsServiceHelper.getValidatorErrorMessage(validatorName, this.errors[validatorName], this.errors[validatorName]?.messageKey);
    }
    return null;
  }

  private async listenToControlChanges(): Promise<void> {
    this.message = await this.errorMessage();
    this.control.valueChanges.subscribe(async (value) => {
      this.message = await this.errorMessage();
    });
    this.injector.get(ChangeDetectorRef).detectChanges();
  }
}
